import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './AdminSettings.css';
import Sidebar from '../components/Sidebar';

interface Admin {
  id: number;
  username: string;
  password: string;
}

const AdminSettings: React.FC = () => {
  const [admins, setAdmins] = useState<Admin[]>([]);
  const [newAdmin, setNewAdmin] = useState({ username: '', password: '' });
  const [editPassword, setEditPassword] = useState('');
  const [selectedAdmin, setSelectedAdmin] = useState<Admin | null>(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    fetchAdmins();
  }, []);

  const fetchAdmins = () => {
    axios.get('http://localhost:5000/admins')
      .then(res => setAdmins(res.data))
      .catch(err => console.error(err));
  };

  const handleAddAdmin = () => {
    if (!newAdmin.username || !newAdmin.password) return;
    axios.post('http://localhost:5000/admins', newAdmin)
      .then(() => {
        fetchAdmins();
        setNewAdmin({ username: '', password: '' });
      });
  };

  const handleDeleteAdmin = (id: number) => {
    axios.delete(`http://localhost:5000/admins/${id}`)
      .then(() => fetchAdmins());
  };

  const handleChangePassword = () => {
    if (!selectedAdmin) return;
    axios.put(`http://localhost:5000/admins/${selectedAdmin.id}`, {
      ...selectedAdmin,
      password: editPassword
    })
      .then(() => {
        fetchAdmins();
        alert('Password updated successfully');
        setSelectedAdmin(null);
        setEditPassword('');
      });
  };

  return (
    <div style={{ display:'flex'}}>  <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
    <div
      style={{
        flex: 1,
        marginLeft: isSidebarOpen ? "250px" : "60px",
        transition: "margin-left 0.3s ease",
        padding: "20px"
      }}
    >
            <div className='main-content1'>

    <div className="admin-settings-container">
      <h2>Admin Accounts</h2>

      <div className="add-admin">
        <input
          type="text"
          placeholder="Username"
          value={newAdmin.username}
          onChange={(e) => setNewAdmin({ ...newAdmin, username: e.target.value })}
        />
        <input
          type="password"
          placeholder="Password"
          value={newAdmin.password}
          onChange={(e) => setNewAdmin({ ...newAdmin, password: e.target.value })}
        />
        <button onClick={handleAddAdmin}>Add Admin</button>
      </div>

      <table>
        <thead>
          <tr>
            <th>Username</th>
            <th>Password</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {admins.map(admin => (
            <tr key={admin.id}>
              <td>{admin.username}</td>
              <td>{admin.password}</td>
              <td>
                <button onClick={() => setSelectedAdmin(admin)}>Change Password</button>
                <button onClick={() => handleDeleteAdmin(admin.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {selectedAdmin && (
        <div className="change-password-box">
          <h4>Change Password for {selectedAdmin.username}</h4>
          <input
            type="password"
            placeholder="New Password"
            value={editPassword}
            onChange={(e) => setEditPassword(e.target.value)}
          />
          <button onClick={handleChangePassword}>Update</button>
        </div>
      )}
    </div>    </div></div></div>

  );
};

export default AdminSettings;
